import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, Fragment } from "react";
import Swiper from "react-id-swiper";
import { getDiscountPrice, getProductCartQty } from "../../helpers/product";
//import Rating from "./sub-components/ProductRating";
import { connect } from "react-redux";
import { Link } from "react-scroll";
import { addToCompare } from "../../redux/actions/compareActions";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/actions/wishlistActions";
import ProductRating from "../../components/product/sub-components/ProductRating";
import { addToCart } from "../../redux/actions/cartActions";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileVideo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ca } from "date-fns/locale";
import ProductSplitView from "./ProductSplitView";
function ProductPageCatalogTemplate(props) {
  const {
    product,
    currency,
    discountedprice,
    finaldiscountedprice,
    isLoggedUser,
    visualizzaPrezzi,
    addToCart,
    addToWishlist,
    removeFromWishlist,
    addtoast,
    description,
    notShowGridAvailability,
    showCatalogo,
    productsListini,
    catalogoTemplate,
    pagina,
    variantOffset,
    offsetPerPage,
    setEditDialog,
    editDialog
  } = props;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;
  const isBetaRicambi = global.aziendaID === 4 ? true : false;
  const discountedPrice = getDiscountPrice(
    product.price,
    product.discount,
    product.pricesco
  );
  const finalDiscountedPrice = product.price
    ? (+(discountedPrice * currency.currencyRate)).toFixed(2)
    : 0;
  const prodottiSenzaLogin = global.prodottiSenzaLogin;

  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);

  if (!product || product.variation === undefined) {
    //console.log(product)
  }
  const [firstColorIndex, setFirstColorIndex] = useState(0);
  const [selectedProductColor, setSelectedProductColor] = useState(
    (product && product.variation
      ? product.variation[firstColorIndex]?.color
      : "") || ""
  );

  const [selectedProductSize, setSelectedProductSize] = useState(
    (product &&
      product.variation.length > 0 &&
      product.variation[firstColorIndex]?.size
      ? product.variation[firstColorIndex].size[0].name
      : "") || ""
  );
  const [selectedProductPrice, setSelectedProductPrice] = useState(
    product &&
      product.variation.length > 0 &&
      product.variation[firstColorIndex]?.size
      ? product.variation[firstColorIndex].size[0].pricesco
      : product.price?.toFixed(2)
  );
  const [selectedIDArt, setSelectedIDArt] = useState(
    product &&
      product.variation.length > 0 &&
      product.variation[firstColorIndex]?.size
      ? product.variation[firstColorIndex].size[0].IDArtSizeColor
      : 0
  );
  const [productStock, setProductStock] = useState(
    product &&
      product.variation.length > 0 &&
      product.variation[firstColorIndex]?.size
      ? product.variation[firstColorIndex].size[0].stock
      : product?.stock || 0
  );
  const [quantityCount, setQuantityCount] = useState(0);

  //const wishlistItem = props.wishlistitem;
  const compareItem = props.compareitem;

  //const addToCart = props.addtocart;
  //const addToWishlist = props.addtowishlist;
  //const removeFromWishlist = props.removeFromWishlist;
  const addToCompare = props.addtocompare;

  //const addtoast = props.addtoast;
  const cartItems = props.cartitems;
  const wishlistItems = props.wishlistItems;

  const wishlistItem = product
    ? wishlistItems.find((_i) => _i.id === product.id)
    : [];

  function fproductCartQty(
    selectedProductColor,
    selectedProductSize,
    withGrid
  ) {
    let cartValue = getProductCartQty(
      cartItems,
      product,
      selectedProductColor,
      selectedProductSize
    );

    //if (withGrid) cartValue +=  getQta(selectedProductSize, selectedProductColor, true);
    return cartValue;
  }
  const ref = useRef(null);

  const productCartQty = getProductCartQty(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize,
    selectedIDArt
  );
  useEffect(() => {
    if (global.aziendaID == 3) calculateVariationsPrices();
    var i = -1;
    product.variation && product.variation.forEach((v, index) => {
      if (v?.size && i == -1) i = index;
    });
    setFirstColorIndex(i);
    //console.log(i);
  }, [product]);

  const calculateVariationsPrices = () => {
    var v = product.variation;
    v = v.map((color) => {
      if (color && color.size) {
        color.size = color.size.map((size) => {
          var listino = productsListini.find(
            (L) => L.IDArt == size.IDArtSizeColor
          )?.Pre;

          size.pricesco = listino ? listino : 0;
          if (listino && listino > 0) color.count = (color.count || 0) + 1;
          return size;
        });
        return color;
      }
    });
    //console.log(v);
    //v = v.filter((color) => color.count > 0);
    product.variation = v;
  };

  useEffect(() => {
    setSelectedProductColor(
      (product && product.variation
        ? product.variation[firstColorIndex]?.color
        : "") || ""
    );
    setSelectedProductSize(
      (product &&
        product.variation.length > 0 &&
        product.variation[firstColorIndex]?.size
        ? product.variation[firstColorIndex].size[0].name
        : "") || ""
    );
    setSelectedProductPrice(
      product &&
        product.variation.length > 0 &&
        product.variation[firstColorIndex]?.size
        ? product.variation[firstColorIndex].size[0].pricesco
        : product.price?.toFixed(2)
    );
    setSelectedIDArt(
      product &&
        product.variation.length > 0 &&
        product.variation[firstColorIndex]?.size
        ? product.variation[firstColorIndex].size[0].IDArtSizeColor
        : 0
    );
    setProductStock(
      product &&
        product.variation.length > 0 &&
        product.variation[firstColorIndex]?.size
        ? product.variation[firstColorIndex].size[0].stock
        : product?.stock || 0
    );
  }, [firstColorIndex]);
  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    loopedSlides: 4,
    loop: true,
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    loopedSlides: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };
  var strings = require("../../translations/italian.json");
  function toColor(i) {
    var r = Math.floor(i / 65536);
    var g = Math.floor((i - r * 65536) / 256);
    var b = Math.floor(i - r * 65536 - g * 256);
    var rHex = Number(r).toString(16);
    var gHex = Number(g).toString(16);
    var bHex = Number(b).toString(16);
    rHex = rHex.length < 2 ? "0" + rHex : rHex;
    gHex = gHex.length < 2 ? "0" + gHex : gHex;
    bHex = bHex.length < 2 ? "0" + bHex : bHex;
    return "#" + bHex + gHex + rHex;

    /*
    var hex = (i & 0xFF).toString(16) +
      ((i >> 8) & 0xFF).toString(16) +
      ((i >> 16) & 0xFF).toString(16) +
      ((i >> 24) & 0xFF).toString(16);

    hex += '000000'; // pad result
    hex = hex.substring(0, 6);
    console.log(i + ' ' + "#" + hex)
    return "#" + hex;*/
  }

  if (!product || !product.id) return null;

  function getDisponibili(
    Qta,
    inArrivo,
    selectedProductColor,
    selectedProductSize,
    catalogo,
    impCli,
    promo,
    nonPrenotabile
  ) {
    var sDis = " ";

    if (Qta <= 0 || Qta - inArrivo <= 0)
      sDis = (
        <div style={{ fontWeight: "500" }}>
          Non Disponibile &nbsp;
          {nonPrenotabile ? <i className="fa fa-bell"></i> : null}
        </div>
      );
    else if (!promo)
      sDis = (
        <div style={{ fontWeight: "500" }}>
          {"Disponibili: " + (Qta - inArrivo > 500 ? "500+" : Qta - inArrivo)}
          <br />
        </div>
      );
    else
      sDis = (
        <div style={{ fontWeight: "500" }}>
          {"Ultimi  " +
            (Qta - inArrivo > 500 ? "500+" : Qta - inArrivo) +
            " pezzi"}
          <br />
        </div>
      );
    //sDis = "Disponibili: " + (Qta - productCartQty(selectedProductColor, selectedProductSize));
    if (catalogo && Qta <= 0) {
      //sDis = <>{sDis}<br/>{"Su prenotazione"}</>
      sDis = (
        <div style={{ fontSize: "12px", fontWeight: "100" }}>
          <br />
          {"Su prenotazione"}
        </div>
      );
    }

    return sDis;
  }

  function getQtaInArrivo(
    qtaOrdFor,
    qtaImpCli,
    qta,
    catalogo,
    promo,
    onlyString
  ) {
    var sDis = " ";
    var Qta = qta - qtaOrdFor > 0 ? qtaOrdFor : qta;
    if (promo)
      return onlyString ? (
        ""
      ) : (
        <p>
          <br />
          <br />
          <br />
        </p>
      );

    if (Qta <= 0 /*|| qtaImpCli < 0*/)
      //sDis = "Non in Arrivo";
      sDis = onlyString ? (
        "su Prenotazione"
      ) : (
        <>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            <br />
            <br />
          </div>
          <div style={{ fontSize: "12px", fontWeight: "100" }}>
            <br />
            Maggiori quantità
            <br />
            su prenotazione
          </div>
        </>
      );
    else
      sDis = onlyString ? (
        (Qta || "0") + " 5/7 gg"
      ) : (
        <>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            In Arrivo: {Qta ? Qta : "0"}
            <br />
            in 5/7 gg
          </div>
          <div style={{ fontSize: "12px", fontWeight: "100" }}>
            <br />
            Maggiori quantità
            <br />
            su prenotazione
          </div>
        </>
      );

    return sDis;
  }

  const getTableInfo = () => {
    //console.log({ isLoggedUser, visualizzaPrezzi, visualizzaGriglia, visualizzaQuantita })
    if (!visualizzaQuantita && !isLoggedUser) return null;

    const colorProduct = product?.variation?.find(
      (_colorProduct) => _colorProduct.color === selectedProductColor
    );
    if (!colorProduct || !colorProduct.size) return null;

    const taglieInfo = colorProduct.size;
    if (!taglieInfo || (taglieInfo || []) === 0) return null;

    const _colorcode = colorProduct.color.split("-")[0];
    const _colorname = colorProduct.color.split("-")[1];
    return (
      <>
        <div>
          <label>
            <span
              title={selectedProductColor.split("-")[1] + " "}
              style={{
                backgroundColor: colorProduct.hexColor
                  ? toColor(colorProduct.hexColor)
                  : "",
                backgroundImage: colorProduct.hexColor
                  ? null
                  : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                  _colorcode +
                  ".png')",
                backgroundSize: "contain",
                position: "absolute",
                width: "20px",
                height: "20px",
                border:
                  colorProduct.color === selectedProductColor
                    ? "2px solid #333"
                    : "2px solid #d9d9d9",
                borderRadius: "50%",
                content: "",
                transition: "0.3s",
              }}
            ></span>
            <span style={{ paddingLeft: "50px" }}>{_colorname}</span>
          </label>
        </div>
        <table id="infoTable" style={{ width: "100%" }}>
          <thead style={{ width: "100%" }}>
            <tr>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "30%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Taglia</span>
              </th>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "35%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Disponibile</span>
              </th>
              <th
                style={{
                  width: isLoggedUser ? "25%" : "35%",
                  backgroundColor: "#c3c3c3",
                  fontWeight: 500,
                  textAlign: "center",
                  padding: "5px",
                  BorderBottom: "0px",
                  BorderRight: "0px",
                  fontSize: "12px",
                  columnSpan: 2,
                  color: "black",
                  border: "1px solid black",
                }}
              >
                <span>Arrivi</span>
              </th>
              {isLoggedUser && (
                <th
                  style={{
                    width: "25%",
                    backgroundColor: "#c3c3c3",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "5px",
                    BorderBottom: "0px",
                    BorderRight: "0px",
                    fontSize: "12px",
                    columnSpan: 2,
                    color: "black",
                    border: "1px solid black",
                  }}
                >
                  <span>Carrello</span>
                </th>
              )}
            </tr>
          </thead>
          <tbody style={{ width: "100%" }}>
            {taglieInfo.map((tagliaInfo) => {
              var nonPrenotabile =
                tagliaInfo.stock <= 0 &&
                tagliaInfo.stock - tagliaInfo.qtaOrdFor <= 0 &&
                tagliaInfo.qtaOrdFor - tagliaInfo.qtaImpCli <= 0 &&
                tagliaInfo.tag?.includes("PROMEMORIA");
              var nonEsiste = tagliaInfo.flgNoWeb == 1;

              return (
                <tr style={{ display: nonEsiste ? "none" : "table-row" }}>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "30%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>{tagliaInfo.name || 0}</span>
                  </td>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "35%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>
                      {getDisponibili(
                        tagliaInfo.stock,
                        tagliaInfo.qtaOrdFor,
                        tagliaInfo.color,
                        tagliaInfo.name,
                        tagliaInfo.catalogo,
                        tagliaInfo.qtaImpCli,
                        tagliaInfo.promo,
                        nonPrenotabile
                      )}
                    </span>
                  </td>
                  <td
                    style={{
                      width: isLoggedUser ? "25%" : "35%",
                      textAlign: "center",
                      padding: "5px",
                      BorderBottom: "0px",
                      BorderRight: "0px",
                      fontSize: "12px",
                      columnSpan: 1,
                      color: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span>
                      {getQtaInArrivo(
                        tagliaInfo.qtaOrdFor,
                        tagliaInfo.qtaImpCli,
                        tagliaInfo.stock,
                        tagliaInfo.catalogo,
                        tagliaInfo.promo,
                        true
                      ) || ""}
                    </span>
                  </td>
                  {isLoggedUser && (
                    <td
                      style={{
                        width: "25%",
                        textAlign: "center",
                        padding: "5px",
                        BorderBottom: "0px",
                        BorderRight: "0px",
                        fontSize: "12px",
                        columnSpan: 1,
                        color: "black",
                        border: "1px solid black",
                        fontWeight: 700,
                      }}
                    >
                      <span>
                        {fproductCartQty(
                          selectedProductColor,
                          tagliaInfo.name,
                          true
                        )}
                      </span>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };

  function onPlusMinusClick(
    bPlus,
    bMsg,
    idArt,
    QtaDisponibili,
    QtaArrivo,
    catalogo,
    promo
  ) {
    var element = document.getElementById(idArt);

    var QtaOrdinate = 0;

    if (bPlus) QtaOrdinate = (element.value ? parseInt(element.value) : 0) + 1;
    else QtaOrdinate = parseInt(element.value) - 1;

    onBlur(idArt, QtaOrdinate, QtaDisponibili, QtaArrivo, catalogo, promo);
  }
  function onBlur(id, QtaOrdinate, QtaDisponibili, QtaArrivo, catalogo, promo) {
    //console.log(qta);
    var element = document.getElementById(id);
    var selectedProductSize = element.getAttribute("data-size");
    var selectedProductColor = element
      .getAttribute("data-color")
      .replace(" ", "");

    //console.log(selectedProductSize + " " + selectedProductColor);
    var QtaOrdinateGestite = gestisciQta(
      QtaOrdinate,
      QtaDisponibili,
      QtaArrivo,
      selectedProductColor,
      selectedProductSize,
      catalogo,
      promo
    );

    var element = document.getElementById(id);
    element.value = QtaOrdinateGestite;
    QtaOrdinate = QtaOrdinateGestite;
    setQuantityCount(QtaOrdinate);
  }

  function gestisciQta(
    QtaOrdinate,
    QtaDisponibili,
    QtaArrivo,
    selectedProductColor,
    selectedProductSize,
    catalogo,
    promo
  ) {
    var iTipoGestione = 2;
    catalogo = 1;
    /*Opzioni Possibili: 
        0   Non Bloccare le Qta
        1   Bloccare + Messaggio a QtaDisponibili < QtaOrdinate
        2   Messaggio a QtaDisponibili < QtaOrdinate
        3   Bloccare + Messaggio a QtaDisponibili + QtaArrivo < QtaOrdinate
        4   Messaggio a QtaDisponibili + QtaArrivo < QtaOrdinate
    */

    var QtaGiaInCarrello = productCartQty;

    var sToast = "";
    var sTipoToast = "info"; //success, error, warning, info
    var QtaConfronto = QtaDisponibili - QtaGiaInCarrello;
    var iTipoGestioneAtt = iTipoGestione;
    if (promo) {
      catalogo = 0;
      iTipoGestioneAtt = 2;
    }
    var QtaPossibili = QtaOrdinate;

    if (iTipoGestioneAtt > 2) {
      QtaConfronto = QtaConfronto + QtaArrivo;
      iTipoGestioneAtt = iTipoGestioneAtt - 2;
    }

    if (QtaOrdinate <= 0) {
      if (QtaOrdinate == 0) return QtaOrdinate;
      addtoast("Quantità non consentite", {
        appearance: "warning",
        autoDismiss: true,
        placement: "bottom-left",
      });
      return 0;
    } else {
      if (catalogo == 1) iTipoGestioneAtt = 0;
      switch (iTipoGestioneAtt) {
        case 0:
          sToast = "Quantità inserite correttamente";
          sTipoToast = "info";
          break;
        case 1:
        case 2:
          if (QtaOrdinate > QtaConfronto) {
            sToast = "Quantità eccessive, non è possibile caricare le quantità";
            sTipoToast = "warning";
            if (iTipoGestioneAtt == 2) {
              QtaPossibili = QtaConfronto < 0 ? 0 : QtaConfronto;
            }
          } else {
            sToast = "Quantità inserite correttamente";
            sTipoToast = "info";
          }
          break;
      }
    }

    //Meglio non farlo visualizzare in continuazione, enilio 29/06/2021 if (sToast != "") addtoast(sToast, {appearance: sTipoToast, autoDismiss: true, placement: 'bottom-left' });

    return QtaPossibili;
  }
  var qtaInCart = getProductCartQty(cartItems, product, null, null);
  //console.log(product)
  return (
    <div className="flex items-center justify-center p-4">
      {!catalogoTemplate && (
        <div className="row p-2">
          <div>
            <div
              className="product-large-image-wrapper"
              style={{
                height: showCatalogo ? "40vh" : "80vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {showCatalogo && (
                <img
                  style={{ height: "100%", padding: "10px" }}
                  id={"image-prod-" + product.id}
                  src={
                    global.baseUrlImage +
                    product.image[0] +
                    "?t=" +
                    Math.random()
                  }
                  onError={() => {
                    var elms = document.querySelectorAll(
                      "[id='" + "image-prod-" + product.id + "']"
                    );
                    for (var i = 0; i < elms.length; i++) {
                      elms[i].src = global.placeholderImage;
                      elms[i].style.objectFit = showCatalogo
                        ? "contain"
                        : "cover";
                    }
                  }}
                  className="img-fluid"
                  alt=""
                />
              )}
              {!showCatalogo && (
                <Swiper {...gallerySwiperParams} ref={ref} key={product.id}>
                  {product.image &&
                    product.image.map((single, key) => {
                      return (
                        <div className="single-image" key={key}>
                          <img
                            style={{
                              width: showCatalogo ? "25vh" : "auto",
                              height: showCatalogo ? "auto" : "80vh",
                            }}
                            id={"image-prod-" + product.id}
                            src={
                              global.baseUrlImage +
                              single +
                              "?t=" +
                              Math.random()
                            }
                            onError={() => {
                              var elms = document.querySelectorAll(
                                "[id='" + "image-prod-" + product.id + "']"
                              );
                              for (var i = 0; i < elms.length; i++) {
                                elms[i].src = global.placeholderImage;
                                elms[i].style.objectFit = showCatalogo
                                  ? "contain"
                                  : "cover";
                              }
                            }}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      );
                    })}
                </Swiper>
              )}
            </div>
            {!showCatalogo && (
              <div className="product-small-image-wrapper mt-15">
                <Swiper {...thumbnailSwiperParams} key={Math.random()}>
                  {product.image &&
                    product.image.map((single, key) => {
                      return (
                        <div key={key}>
                          <div className="img-gallery-thumb">
                            <img
                              id={"image-prod-" + product.id}
                              src={
                                global.baseUrlImage +
                                single +
                                "?t=" +
                                Math.random()
                              }
                              className="img-fluid"
                              alt=""
                              onClick={(e) => {
                                ref.current.swiper.slideTo(key);
                                e.preventDefault();
                              }}
                              onError={() => {
                                document.getElementById(
                                  "image-prod-" + product.id
                                ).src = global.placeholderImage;
                                document.getElementById(
                                  "image-prod-" + product.id
                                ).style.objectFit = "contain";
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                </Swiper>
              </div>
            )}
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="product-details-content quickview-content">
              <h2>{product.name}</h2>
              <div
                className="product-details-price"
                style={{ marginTop: "10px", marginBottom: "10px" }}
              >
                {
                  /*discountedprice !== null ? (
                    <Fragment>
                      <span>
                        {currency.currencySymbol + finaldiscountedprice}
                      </span>{" "}
                      {/*<span className="old">
                        {currency.currencySymbol + finalproductprice}
                  </span>
                    </Fragment>
                  ) : */
                  (isBetaRicambi
                    ? visualizzaPrezzi
                    : isLoggedUser || visualizzaPrezzi) && (
                    <span>
                      {isBetaRicambi && (
                        <Fragment>
                          <span>
                            {currency.currencySymbol +
                              (finalDiscountedPrice
                                ? finalDiscountedPrice
                                : product.price.toFixed(2))}
                          </span>{" "}
                        </Fragment>
                      )}
                      <span
                        style={{ display: isBetaRicambi ? "none" : "block" }}
                      >
                        {currency.currencySymbol +
                          parseFloat(selectedProductPrice).toFixed(2)}{" "}
                      </span>
                    </span>
                  )
                }
              </div>
              {isLoggedUser && product.rating && product.rating > 0 ? (
                <div
                  className="pro-details-rating-wrap"
                  style={{ display: "none" }}
                >
                  <div className="pro-details-rating">
                    <ProductRating ratingValue={product.rating} />
                  </div>
                </div>
              ) : (
                ""
              )}
              {/*<div className="pro-details-list"> descrizione emilio io la metterei in baso
                  <p>{product.shortDescription}</p>
              </div>*/}

              {product.variation.length > 0 ? (
                <div
                  className="pro-details-size-color"
                  style={{ display: "inline-block" }}
                >
                  <div className="pro-details-color-wrap">
                    <span>{product.altdat1}</span>
                    <div className="pro-details-color-content">
                      {product.variation.map((single, key) => {
                        return single.size == undefined ||
                          single.size?.length == 0 ? (
                          <></>
                        ) : (
                          <label
                            className={`pro-details-color-content--single ${single.color}`}
                            key={key}
                          >
                            <input
                              type="radio"
                              value={single.color}
                              name="product-color"
                              checked={
                                single.color === selectedProductColor
                                  ? "checked"
                                  : ""
                              }
                              onChange={() => {
                                if (single.size) {
                                  setSelectedProductColor(single.color);
                                  setSelectedProductSize(single.size[0].name);
                                  setSelectedIDArt(
                                    single.size[0].IDArtSizeColor
                                  );
                                  setProductStock(single.size[0].stock);
                                  setSelectedProductPrice(
                                    single.size[0].pricesco
                                  );
                                  setQuantityCount(0);
                                }
                              }}
                            />
                            <span
                              style={{
                                backgroundColor: single.hexColor
                                  ? toColor(single.hexColor)
                                  : "",
                                backgroundImage: single.hexColor
                                  ? null
                                  : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                                  single.color.split("-")[0] +
                                  ".png')",
                                backgroundSize: "contain",
                                position: "absolute",
                                top: "-7px",
                                left: "-4px",
                                width: "20px",
                                height: "20px",
                                border:
                                  single.color === selectedProductColor
                                    ? "2px solid #333"
                                    : "2px solid #d9d9d9",
                                borderRadius: "50%",
                                content: "",
                                transition: "0.3s",
                              }}
                            ></span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                  <div className="pro-details-size">
                    <span>{product.altdat2}</span>
                    <div className="pro-details-size-content">
                      {product.variation &&
                        product.variation.map((single) => {
                          return single.color === selectedProductColor &&
                            single.size
                            ? single.size.map((singleSize, key) => {
                              var nonPrenotabile =
                                singleSize.stock <= 0 &&
                                singleSize.stock - singleSize.qtaOrdFor <=
                                0 &&
                                singleSize.qtaOrdFor - singleSize.qtaImpCli <=
                                0 &&
                                singleSize.tag?.includes("PROMEMORIA");
                              var nonEsiste = singleSize.flgNoWeb == 1;
                              return (
                                <label
                                  className={`pro-details-size-content--single`}
                                  key={key}
                                  style={{
                                    color:
                                      nonPrenotabile == 1
                                        ? "lightgray"
                                        : "black",
                                    display:
                                      nonEsiste == 1
                                        ? "none"
                                        : "inline-block",
                                  }}
                                >
                                  <input
                                    type="radio"
                                    value={singleSize.name}
                                    checked={
                                      singleSize.name === selectedProductSize
                                        ? "checked"
                                        : ""
                                    }
                                    disabled={nonPrenotabile == 1}
                                    onChange={() => {
                                      setSelectedProductSize(singleSize.name);
                                      setSelectedIDArt(
                                        singleSize.IDArtSizeColor
                                      );
                                      setProductStock(singleSize.stock);
                                      setSelectedProductPrice(
                                        singleSize.pricesco
                                      );
                                      setQuantityCount(0);
                                    }}
                                  />
                                  <span className="size-name">
                                    {singleSize.name}
                                  </span>
                                </label>
                              );
                            })
                            : "";
                        })}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {product.category && !isBetaRicambi ? (
                <div className="pro-details-meta">
                  <span>Categorie :</span>
                  <ul>{product.category}</ul>
                </div>
              ) : (
                ""
              )}
              {isBetaRicambi ? (
                <div
                  className="pro-details-meta"
                  style={{ flexDirection: "column", alignItems: "flex-start" }}
                >
                  <div style={{ display: product.category ? "flex" : "none" }}>
                    <span>Categoria :</span>
                    <ul>{product.category}</ul>
                  </div>
                  <div
                    style={{ display: product.subcategory ? "flex" : "none" }}
                  >
                    <span>Sottocategoria :</span>
                    <ul>{product.subcategory}</ul>
                  </div>
                  <div style={{ display: product.brands ? "flex" : "none" }}>
                    <span>Modello :</span>
                    <ul>{product.brands}</ul>
                  </div>
                  <div style={{ display: product.templates ? "flex" : "none" }}>
                    <span>Marca :</span>
                    <ul>{product.templates}</ul>
                  </div>
                </div>
              ) : (
                ""
              )}
              {product?.tag?.length && global.aziendaID != 3 ? (
                <div className="pro-details-meta">
                  <span style={{ width: "15%" }}>Tags :</span>
                  <ul>
                    {product.tag.map((single, key) => {
                      return (
                        <li key={key}>
                          <Link
                            to={
                              process.env.PUBLIC_URL + "/shop-grid-full-width"
                            }
                          >
                            {single}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
              {product.files?.map((file, index) => {
                // Funzione per ottenere l'icona in base all'estensione del file
                const getFileIcon = (fileName) => {
                  // Assumiamo che file.name contenga il nome del file completo
                  const name =
                    typeof fileName === "object" &&
                      fileName !== null &&
                      fileName.name
                      ? fileName.name
                      : fileName;
                  const extension = name.split(".").pop().toLowerCase();
                  switch (extension) {
                    case "pdf":
                      return faFilePdf;
                    case "doc":
                    case "docx":
                      return faFileWord;
                    case "xls":
                    case "xlsx":
                      return faFileExcel;
                    case "jpg":
                    case "jpeg":
                    case "png":
                    case "gif":
                      return faFileImage;
                    case "zip":
                    case "rar":
                    case "7z":
                      return faFileArchive;
                    case "mp3":
                    case "wav":
                      return faFileAudio;
                    case "mp4":
                    case "avi":
                    case "mov":
                      return faFileVideo;
                    default:
                      return faFileAlt; // Icona generica per altri tipi di file
                  }
                };

                // Determina l'icona e il testo da visualizzare
                const icon = getFileIcon(file);
                const fileNameToDisplay =
                  typeof file === "object" && file !== null && file.name
                    ? file.name
                    : file;

                return (
                  <div
                    key={index}
                    style={{
                      // Larghezza del 30% per permettere 3 pulsanti per riga con gap
                      flex: "0 0 calc(33.33% - 10px)", // 10px è 2/3 del gap totale (15px) diviso per lato
                      maxWidth: "calc(33.33% - 10px)", // Assicura che non superi la larghezza
                      minWidth: "150px", // Larghezza minima per evitare che siano troppo piccoli su schermi ridotti
                      textAlign: "center", // Centra il contenuto del div (il pulsante)
                    }}
                  >
                    <a
                      href={global.endPointBaseFiles + fileNameToDisplay}
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{
                        display: "flex",
                        flexDirection: "column", // Stack icona e testo verticalmente
                        alignItems: "center", // Centra orizzontalmente icona e testo
                        justifyContent: "center",
                        padding: "15px 10px", // Padding del pulsante
                        border: "1px solid #ddd", // Bordo sottile e leggero
                        borderRadius: "8px",
                        backgroundColor: "#ffffff", // Sfondo bianco
                        color: "#333", // Testo grigio scuro
                        textDecoration: "none",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)", // Ombra più sottile
                        transition: "all 0.3s ease",
                        height: "100%", // Assicura che i pulsanti abbiano la stessa altezza se il testo varia
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f0f0f0"; // Leggero grigio al hover
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 8px rgba(0, 0, 0, 0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#ffffff"; // Torna al bianco
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 4px rgba(0, 0, 0, 0.08)";
                      }}
                    >
                      <FontAwesomeIcon
                        icon={icon}
                        style={{
                          marginBottom: "8px",
                          fontSize: "32px",
                          color: "#007bff",
                        }}
                      />{" "}
                      {/* Icona più grande e colorata */}
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          textAlign: "center",
                          wordBreak: "break-word",
                        }}
                      >
                        {fileNameToDisplay}
                      </span>
                    </a>
                  </div>
                );
              })}
              {product.affiliateLink ? (
                <div className="pro-details-quality">
                  <div className="pro-details-cart btn-hover">
                    <a
                      href={product.affiliateLink}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Buy Now
                    </a>
                  </div>
                </div>
              ) : (
                isLoggedUser && (
                  <>
                    <div className="pro-details-meta">
                      <span
                        style={{
                          textAlignLast: "center",
                          width: "100%",
                          fontWeight: 900,
                          color: "blue",
                          display: selectedProductSize ? "block" : "none",
                        }}
                      >
                        {selectedProductSize +
                          " - " +
                          selectedProductColor.split("-")?.[1]}
                      </span>
                    </div>

                    <div
                      className="pro-details-quality"
                      style={{ margin: "0px" }}
                    >
                      {product.variation.length == 0 && (
                        <span>{qtaInCart} pz già nel carrello</span>
                      )}
                      <div className="cart-plus-minus">
                        <button
                          onClick={() =>
                            /*{
                        const colorProduct = product?.variation?.find(c => c.color === selectedProductColor);
                        const s = colorProduct?.size.find(s => s.name === selectedProductSize)
                        onPlusMinusClick(false, true, s.IDArtSizeColor, s.stock, s.qtaOrdFor, s.catalogo, s.promo)

                      }*/
                            setQuantityCount(
                              quantityCount > 1 ? quantityCount - 1 : 1
                            )
                          }
                          className="dec qtybutton"
                        >
                          -
                        </button>

                        <input
                          id={selectedIDArt}
                          data-size={selectedProductSize}
                          data-color={selectedProductColor}
                          data-type={"InsQta"}
                          className="cart-plus-minus-box"
                          type="numeric"
                          value={quantityCount}
                          onChange={(e) => {
                            const colorProduct = product?.variation?.find(
                              (c) => c.color === selectedProductColor
                            );
                            const s = colorProduct?.size?.find(
                              (s) => s.name === selectedProductSize
                            );
                            if (s)
                              onBlur(
                                s.IDArtSizeColor,
                                e.target.value,
                                s.stock,
                                s.qtaOrdFor,
                                s.catalogo,
                                s.promo
                              );
                            //setQuantityCount(e.target.value)
                          }}
                        //readOnly
                        />
                        <button
                          /*onClick={() =>
                        setQuantityCount(
                          quantityCount < productStock - productCartQty
                            ? quantityCount + 1
                            : quantityCount
                        )
                      }*/
                          onClick={() =>
                            /*{
                        const colorProduct = product?.variation?.find(c => c.color === selectedProductColor);
                        const s = colorProduct?.size.find(s => s.name === selectedProductSize)
                        if (s) onPlusMinusClick(true, true, s.IDArtSizeColor, s.stock, s.qtaOrdFor, s.catalogo, s.promo)
                      }*/
                            setQuantityCount(quantityCount + 1)
                          }
                          className="inc qtybutton"
                        >
                          +
                        </button>
                      </div>

                      <div className="pro-details-cart btn-hover">
                        {(productStock && productStock > 0) || true ? (
                          <button
                            onClick={() => {
                              if (quantityCount == 0) return;
                              const colorProduct = product?.variation?.find(
                                (c) => c.color === selectedProductColor
                              );
                              const tagliaInfo = colorProduct?.size.find(
                                (s) => s.name === selectedProductSize
                              );
                              var nonPrenotabile = false;
                              var nonEsiste = false;
                              if (global.aziendaID == 2) {
                                nonPrenotabile = false;
                                nonEsiste = false;
                              } else {
                                nonPrenotabile =
                                  tagliaInfo.stock <= 0 &&
                                  tagliaInfo.stock - tagliaInfo.qtaOrdFor <=
                                  0 &&
                                  tagliaInfo.qtaOrdFor - tagliaInfo.qtaImpCli <=
                                  0 &&
                                  tagliaInfo.tag?.includes("PROMEMORIA");
                                nonEsiste = tagliaInfo.flgNoWeb == 1;
                              }
                              if (nonPrenotabile || nonEsiste) {
                                //addtoast('L\'articolo non può essere aggiunto al carrello', { appearance: "error", autoDismiss: true, placement: 'bottom-left' });
                                return;
                              }
                              //console.log(selectedIDArt);
                              addToCart(
                                product,
                                addtoast,
                                quantityCount,
                                selectedProductColor,
                                selectedProductSize,
                                selectedIDArt,
                                tagliaInfo?.Ord1,
                                tagliaInfo?.Ord2,
                                setQuantityCount
                              );
                              setQuantityCount(0);
                            }}
                          //disabled={productCartQty >= productStock}
                          >
                            {" "}
                            {strings.add_to_cart}
                          </button>
                        ) : (
                          <button disabled>Out of Stock</button>
                        )}
                      </div>

                      {isLoggedUser ? (
                        wishlistItem !== undefined ? (
                          <div className="pro-details-wishlist">
                            <button
                              style={{
                                borderColor: "transparent",
                                backgroundColor: "transparent",
                              }}
                              className={"active"}
                              disabled={false}
                              title={"Rimuovi dai preferiti"}
                              onClick={() =>
                                removeFromWishlist(product, addtoast)
                              }
                            >
                              <i
                                style={{ color: "lightblue" }}
                                class="fa fa-heart fa-2x"
                                title="Rimuovi dai preferiti"
                              ></i>
                            </button>
                          </div>
                        ) : (
                          <div className="pro-details-wishlist">
                            <button
                              style={{
                                borderColor: "transparent",
                                backgroundColor: "transparent",
                              }}
                              className={"active"}
                              disabled={false}
                              title={"Aggiungi ai preferiti"}
                              onClick={() => addToWishlist(product, addtoast)}
                            >
                              <i
                                class="fa fa-heart-o fa-2x"
                                title="Aggiungi ai preferiti"
                              ></i>
                            </button>
                          </div>
                        )
                      ) : null}

                      {/*              <div className="pro-details-compare" style={{ display: "none" }}>
                    <button
                      className={compareItem !== undefined ? "active" : ""}
                      disabled={compareItem !== undefined}
                      title={
                        compareItem !== undefined
                          ? "Added to compare"
                          : "Add to compare"
                      }
                      onClick={() => addToCompare(product, addtoast)}
                    >
                      <i className="pe-7s-shuffle" />
                    </button>
                    </div>*/}
                    </div>
                  </>
                )
              )}

              {!notShowGridAvailability && getTableInfo()}
              <div className="pro-details-list">
                {/*<p>{product.shortDescription}</p>*/}
                <div
                  style={{ width: "150%", fontSize: "12px" }}
                  dangerouslySetInnerHTML={{
                    __html: description?.DesWeb?.replace(
                      "border-collapse: collapse; width: 100%;",
                      "border-collapse: collapse; border: none; width: 70%;"
                    ),
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
      {false && (
        <div className="row " style={{ height: "800px" }}>
          <div
            className="col-12 text-center"
            style={{
              marginTop: "20px",
              fontWeight: "bold",
              fontFamily: "Lobster",
              fontSize: "25px",
              backgroundColor: "#91c2db",
              paddingTop: "10px",
              paddingBottom: "10px",
              height: "55px",
            }}
          >
            {product.name}
          </div>
          <div
            className="flex flex-row "
            style={{ height: "65vh" }} // 1. ALTEZZA FISSA SUL GENITORE
          >
            {/* COLONNA SINISTRA: Immagine Principale */}
            {/* flex-1: occupa tutto lo spazio orizzontale rimanente */}
            <div className="flex-1 h-full relative bg-white">
              <img
                src={pagina.urlFile}
                // h-full w-full: forza l'immagine a riempire il div genitore
                // object-contain: Mantiene le proporzioni ed evita che l'immagine venga tagliata o deformata
                className="h-full w-full"
                style={{ height: "65vh" }} // 1. ALTEZZA FISSA SUL GENITORE
                alt="Main Product"
              />
            </div>

            {/* COLONNA DESTRA: Variazioni */}
            {/* w-24: larghezza fissa per la colonna laterale */}
            <div
              className="flex flex-col h-full w-24 ml-2 min-h-0 overflow-y-auto"
              style={{ flexDirection: "column" }}
            >
              {product.variation.length > 0 &&
                product.variation.map((single, key) => (
                  <div
                    key={key}
                    // flex-1 qui è cruciale: divide l'altezza 65vh equamente per il numero di immagini
                    className="flex-1 relative min-h-0"
                  >
                    <img
                      // absolute + inset-0: l'immagine si "spalma" dentro il quadratino calcolato
                      className="absolute inset-0 w-full h-full object-contain p-1"
                      src={
                        global.baseUrlImage +
                        single.size[0].skuSizeColor +
                        ".png" +
                        "?t=" +
                        Math.random()
                      }
                      alt="Variation"
                    />
                  </div>
                ))}
            </div>
          </div>
          <div
            className="col-12 text-center"
            style={{
              marginTop: "20px",
              fontWeight: "bold",
              fontFamily: "Poppins",
              fontSize: "15px",
              backgroundColor: "#f9e68a",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          >
            {product.altdat3}
          </div>
        </div>
      )}
      {catalogoTemplate && (
        <ProductSplitView
          description={
            product.shortDesription.length > 0
              ? product.shortDesription
              : product.name
          }
          measure={product.altdat3}
          imageModel={pagina.urlFile}
          template={pagina.template}
          product={product}
          ord={pagina.ord}
          pagina={pagina}
          variantOffset={variantOffset}
          offsetPerPage={offsetPerPage}
          listini={productsListini}
          setEditDialog={setEditDialog}
          editDialog={editDialog}
        />
      )}
    </div>
  );
}

ProductPageCatalogTemplate.propTypes = {
  addtoast: PropTypes.func,
  addtocart: PropTypes.func,
  addtocompare: PropTypes.func,
  addtowishlist: PropTypes.func,
  addtowishlist: PropTypes.func,
  cartitems: PropTypes.array,
  wishlistItems: PropTypes.array,
  compareitem: PropTypes.object,
  currency: PropTypes.object,
  discountedprice: PropTypes.number,
  finaldiscountedprice: PropTypes.number,
  finalproductprice: PropTypes.number,
  onHide: PropTypes.func,
  product: PropTypes.object,
  show: PropTypes.bool,
  //wishlistitem: PropTypes.object
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addtoast,
      quantityCount,
      selectedProductColor,
      selectedProductSize,
      selectedIDArt,
      ord1,
      ord2,
      qta
    ) => {
      dispatch(
        addToCart(
          item,
          addtoast,
          quantityCount,
          selectedProductColor,
          selectedProductSize,
          selectedIDArt,
          ord1,
          ord2,
          qta
        )
      );
    },

    removeFromWishlist: (item, addtoast) => {
      dispatch(removeFromWishlist(item, addtoast));
    },
    addToWishlist: (item, addtoast) => {
      dispatch(addToWishlist(item, addtoast));
    },
    addToCompare: (item, addtoast) => {
      dispatch(addToCompare(item, addtoast));
    },
  };
};

const mapStateToProps = (state, ownProps) => {
  if (!ownProps.product) console.log(ownProps.pagina);
  const productId = ownProps.product.id;

  return {
    cartitems: state.cartData,
    wishlistItems: state.wishlistData,
    currency: state.currencyData,
    description: state.productData.productDescriptions?.filter(
      (D) => D.ID == productId
    )[0],
    productsListini:
      state.productData.productListini instanceof String
        ? JSON.parse(state.productData.productListini)
        : state.productData.productListini,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductPageCatalogTemplate);
